
let titleDialogUnSavedChanges = "";
let contentDialogUnSavedChanges = "";

export function initialize(translatedTitleDialogUnSavedChanges: string, translatedContentDialogUnSavedChanges: string): void {
    titleDialogUnSavedChanges = translatedTitleDialogUnSavedChanges;
    contentDialogUnSavedChanges = translatedContentDialogUnSavedChanges;
}

export function getTitleDialogUnSavedChanges(): string {
    return titleDialogUnSavedChanges;
}

export function getContentDialogUnSavedChanges(): string {
    return contentDialogUnSavedChanges;
}
